<template>
    <div class="radio-like-card"
        :class="{ 'radio-like-card_selected': isSelected }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'RadioLikeCard',
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.radio-like-card {
    border: 1px solid $rfx-medium-steel;
    border-radius: 8px;
    padding: 16px 48px 16px 16px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 16px;
        right: 16px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid $rfx-medium-steel;
        box-sizing: border-box;
    }

    &_selected {
        border: 1px solid $rfx-medium-march;

        &::before {
            border-color: $rfx-medium-march;
            border-width: 4px;
        }
    }
}
</style>